import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import type { TodoListDetailResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UsePublicTodoListReturn {
  list: TodoListDetailResponse | null;
  loading: boolean;
  error: string | null;
}

export function usePublicTodoList(slug: string): UsePublicTodoListReturn {
  const { data, isLoading, error } = useQuery({
    queryKey: queryKeys.todoLists.public(slug),
    queryFn: () => api.getPublicTodoList(slug),
    enabled: !!slug,
  });

  return {
    list: data ?? null,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load todo list' : null,
  };
}
